// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indicator-title-setting {
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
}
.indicator-title-setting__row {
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}
.indicator-title-setting__title {
  width: 125px;
  margin-right: 16px;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/Settings/IndicatorTitleSetting/IndicatorTitleSetting.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,aAAA;EACA,sBAAA;AACJ;AACI;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AACR;AAEI;EACI,YAAA;EACA,kBAAA;EACA,cAAA;AAAR","sourcesContent":[".indicator-title-setting {\n  margin-bottom: 30px;\n  display: flex;\n  flex-direction: column;\n}\n.indicator-title-setting__row {\n  margin-bottom: 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n}\n.indicator-title-setting__title {\n  width: 125px;\n  margin-right: 16px;\n  flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
